"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var warning_1 = __importDefault(require("warning"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var styles = function styles(_ref) {
  var _truncate, _truncateHidden, _truncateCurrent;

  var breakpoints = _ref.breakpoints,
      spacing = _ref.spacing;
  return createStyles_1.createStyles({
    root: {
      paddingRight: spacing(1),
      display: 'flex',
      alignItems: 'center',
      '&:not(:last-child)': {
        flexGrow: 1,
        '&::after': {
          content: '""',
          height: '1px',
          flexGrow: 1,
          minWidth: spacing(4),
          backgroundColor: '#ddd',
          marginLeft: spacing(1)
        }
      }
    },
    labelBottom: {
      alignItems: 'flex-start',
      '&:not(:last-child)::after': {
        marginTop: '0.75em'
      }
    },
    labelTop: {
      alignItems: 'flex-end',
      '&:not(:last-child)::after': {
        marginBottom: '0.75em'
      }
    },
    truncate: (_truncate = {}, _truncate[breakpoints.down('xs')] = {
      flexGrow: '0 !important',
      '&::after': {
        display: 'none'
      }
    }, _truncate),
    truncateHidden: (_truncateHidden = {}, _truncateHidden[breakpoints.down('xs')] = {
      visibility: 'hidden',
      width: 0,
      padding: 0
    }, _truncateHidden),
    truncateCurrent: (_truncateCurrent = {}, _truncateCurrent[breakpoints.down('xs')] = {
      paddingRight: spacing(0.5)
    }, _truncateCurrent)
  });
};

var Step = React.forwardRef(function (props, ref) {
  var _clsx_1$default;

  var _a = props,
      children = _a.children,
      classes = _a.classes,
      index = _a.index,
      current = _a.current,
      next = _a.next,
      last = _a.last,
      completed = _a.completed,
      labelLocation = _a.labelLocation,
      truncate = _a.truncate,
      setCurrentTitle = _a.setCurrentTitle,
      setNextTitle = _a.setNextTitle,
      other = __rest(_a, ["children", "classes", "index", "current", "next", "last", "completed", "labelLocation", "truncate", "setCurrentTitle", "setNextTitle"]);

  var className = clsx_1.default(classes.root, (_clsx_1$default = {}, _clsx_1$default[classes.labelBottom] = labelLocation === 'bottom', _clsx_1$default[classes.labelTop] = labelLocation === 'top', _clsx_1$default[classes.truncate] = truncate, _clsx_1$default[classes.truncateCurrent] = truncate && current && !last, _clsx_1$default[classes.truncateHidden] = truncate && (!current && !last || completed), _clsx_1$default), props.className);
  return React.createElement("li", Object.assign({
    className: className,
    ref: ref
  }, other), React.Children.map(children, function (child) {
    if (!React.isValidElement(child)) {
      return null;
    }

    warning_1.default(child.type !== React.Fragment, ["Unifi: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));

    if (current && setCurrentTitle) {
      setCurrentTitle(child.props.children);
    }

    if (next && setNextTitle) {
      setNextTitle(child.props.children);
    }

    return React.cloneElement(child, Object.assign({
      index: index,
      current: current,
      completed: completed,
      last: last,
      labelLocation: labelLocation,
      truncate: truncate
    }, child.props));
  }));
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiStep'
})(Step);